import {
  ControlledDatePicker
} from '@@viewCommonComponents/controlled';
import { isRequiredInput } from '@@viewHelpers/validations';

const SimulationCustomerGranteesExtraCompanyInformation = ({ form }) => {
  return (

    <ControlledDatePicker
      name="company.creationDate"
      label="Date de création de l’entreprise"
      data-testid="ADHERENT_COMPANY_CREATION_DATE"
      form={form}
      rules={isRequiredInput(true)}
    />

  );
};

export default SimulationCustomerGranteesExtraCompanyInformation;
